export default "__VITE_ASSET__CAuMWGPw__"